import React from "react";
import { Descriptation, Header } from "./Truncate.styles.js";

const Truncate = ({ header, headerLength, str, number, ...rest }) => {
  return (
    <>
      {header && (
        <Header {...rest}>
          {headerLength && header.length > headerLength
            ? header.substring(0, headerLength) + "..."
            : header}
        </Header>
      )}

      {str && (
        <Descriptation
          {...rest}
          dangerouslySetInnerHTML={{
            __html:
              number && str.length > number
                ? str.substring(0, number) + "..."
                : str,
          }}
        />
      )}
    </>
  );
};

export default Truncate;
